/**
 *
 * Grid
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { CAROUSEL_ITEM_PADDING } from '../../Carousel';
import Card from './Card';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${CAROUSEL_ITEM_PADDING.xs * 2}px;
    margin: ${({ theme }) => `0 ${theme?.pageTemplate?.paddingLeftRight?.xs};`};
`;

const Grid = (props) => {

    const {
        isLoading,
        list,
        onItemClickHandler,
        ...otherProps
    } = props;

    return (
        <Wrapper {...otherProps}>
            {list.map((item, index) => (
                <Card
                    key={`item-${index}`}
                    loading={isLoading}
                    index={index}
                    category={item.title}
                    imageTemplateUrl={item.imageTemplateUrl}
                    link={item.link}
                    onClick={onItemClickHandler}
                />
            ))}
        </Wrapper>
    );

};

Grid.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    onItemClickHandler: PropTypes.func.isRequired,
    list: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            imageTemplateUrl: PropTypes.string,
            link: PropTypes.string,
        })
    ),
};

Grid.defaultProps = {
    list: [],
};

export default Grid;
